import React from 'react';

const ProgressSlider = props => {
    const {
        listRef,
        innerListRefs,
        scrollLeft,
        totalItems
    } = props

    let pixelsFromLeft = 0
    let barWidth = 0

    if (listRef) {
        let totalWidth = 0

        innerListRefs.forEach(ref => {
            totalWidth += ref.getBoundingClientRect().width
        })

        const percentFromLeft = scrollLeft / (totalWidth - 500)

        barWidth = totalItems == 4 ? 100 : 60

        const barWidthWithPadding = barWidth + 40
        const sliderWidth = listRef.getBoundingClientRect().width

        pixelsFromLeft = (sliderWidth - barWidthWithPadding) * percentFromLeft
    }

    return (
        <div className="progress-slider">
            <div
                style={{
                    transform: 'translateX(' + pixelsFromLeft + 'px)',
                    width: barWidth + 'px'
                }}
            />
        </div>
    )
};

export default ProgressSlider;



// WEBPACK FOOTER //
// ./src/components/progress-slider/progress-slider.jsx